import React, { useState } from 'react'
import { Card, Form, Input, Button, Col, Row, } from "antd";

import { v4 as uuidv4 } from 'uuid';

function AgreementSignerItemFields(prop) {

    const initialList = [{ id: uuidv4() },];
    const [propertyGroupList, setPropertyGroupList] = useState(initialList);

    function handlePropertyGroupRemove(id) {
        const newList = propertyGroupList.filter((item) => item.id !== id);
        setPropertyGroupList(newList);
    }

    function handleAddPropertyGroupItem() {
        const newList = propertyGroupList.concat({ id: uuidv4() });
        setPropertyGroupList(newList);
    }
    return (
        <ul>
            
            {propertyGroupList.map((item) => (
                <li key={item.id}>
                    <Form.Item>
                        <Row style={{ marginTop: 22 }}>
                            <Col span={3}>
                                <h5>Signer:</h5>
                            </Col>

                            <Col span={18}>

                                <Form.Item
                                    name="firstName"
                                    label="Legal First Name"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    name="lastName"
                                    label="Legal Last Name"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    name="emailAddress"
                                    label="Email Address"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>

                            </Col>

                            <Col span={3}>

                                {propertyGroupList.length > 1 ? (<> <Button className="roundSmallButton" onClick={() => { handlePropertyGroupRemove(item.id) }} type="primary" shape="circle" icon={<i className="fa-sharp fa-solid fa-xmark"></i>} size={"small"} /></>) : (<></>)}

                            </Col>

                        </Row>
                    </Form.Item>
                </li>
            ))}
            <Button className="addPropertyGroupButton" type="primary" onClick={handleAddPropertyGroupItem} size={"small"} icon={<i className="fa-solid fa-circle-plus" ></i>}> Add Another Property Group</Button>

        </ul>
    )
}

export default AgreementSignerItemFields